const arrayOfCardTypes = ["visa", "master", "american"];

export default arrayOfCardTypes;